<template>
  <section class="grid grid-cols-2 lg:grid-cols-4 gap-4 pb-40 h-fit">
    <PageHeader container_class="col-span-2" :title="page_title" :subtitle="formatDate(today)"> </PageHeader>
    <Card card_class="row-start-2 col-span-1 lg:col-span-1">
      <img
        src="images/icons/product.webp"
        width="40"
        height="40"
        alt="product"
        class="mb-1"
      />
      <p class="mb-4">Product Total</p>
      <h5 class="font-semibold text-[1.5rem]">{{ products_count }} Produk</h5>
    </Card>
    <card card_class="row-start-2 col-span-1">
      <img
        src="images/icons/customer.webp"
        alt="customer"
        height="40"
        width="40"
        class="mb-1"
      />
      <p class="mb-4">Customer Total</p>
      <h5 class="font-semibold text-[1.5rem]">{{ customers_count }} Customers</h5>
    </card>
    <div class="col-start-1 col-span-2 h-fit flex items-center gap-4">
      <ButtonRouter
        button_text="&#43; New Transaction"
        button_class=""
        path="transaction/new"
      />
    </div>
    <Card card_class="col-start-1 col-span-2 lg:col-span-4 max-h-96 overflow-y-scroll" card_title="Today's Reminders">
      <DinamicTable :header_columns="table_header_today_reminder" th_class="text-left">
        <TableRow v-for="(reminder, index) in filteredReminders" :key="index">
          <TableCell>{{ reminder?.title }}</TableCell>
          <TableCell>{{ reminder?.Customer?.name }}</TableCell>
          <TableCell>{{ reminder?.Transaction?.transaction_date ? formatDate(reminder.Transaction.transaction_date) : '-' }}</TableCell>
          <TableCell>{{ reminder?.Product?.products_name }}</TableCell>
          <TableCell>
            <BadgeSuccess v-if="reminder?.status == 'done'" text="Done" badge_class="text-xs" />
            <BadgeWarning v-else text="not reminded yet" badge_class="text-xs" />
          </TableCell>
        </TableRow>
      </DinamicTable>
      <div class="flex justify-end mt-4">
        <ButtonRouter button_class="text-sm" button_text="See All Reminders &#10095;" path="/reminder" />
      </div>
    </Card>
    <Card card_title="Customer's Birthdate Reminders" card_class="col-span-4 max-h-96 overflow-y-scroll">
      <div class="flex mb-4">
        <InputForm
          id="customer-filter-start-date"
          v-model="customer_filter.start_date"
          input_class="w-full"
          label="Start Date"
          label_class="mb-1 block text-start"
          type="date"
          @change="fetchCustomers()"
        />
        <InputForm
          id="customer-filter-end-date"
          v-model="customer_filter.end_date"
          input_class="w-full"
          label="End Date"
          label_class="mb-1 block text-start"
          type="date"
          @change="fetchCustomers()"
        />
      </div>
      <DinamicTable :header_columns="table_header_birthday_reminder" th_class="text-left">
        <TableRow v-for="(customer, index) in filteredBirthdayCustomers" :key="index">
          <TableCell>{{ customer?.name }}</TableCell>
          <TableCell>{{ customer?.birthdate ? formatDate(customer?.birthdate) : '-' }}</TableCell>
          <TableCell>{{ customer?.phone_number }}</TableCell>
          <TableCell>{{ customer?.last_transaction_date ? formatDate(customer?.last_transaction_date) : '-' }}</TableCell>
        </TableRow>
      </DinamicTable>
    </Card>
  </section>
</template>

<script>
import DinamicTable from "@/components/organisms/DinamicTable.vue";
import TableRow from "@/components/atoms/table/TableRow.vue";
import TableCell from "@/components/atoms/table/TableCell.vue";
import Card from "@/components/organisms/Card.vue";
import ButtonRouter from "@/components/buttons/ButtonRouter.vue";
import ButtonIcon from "@/components/buttons/ButtonIcon.vue";
import PageHeader from "@/components/molecules/PageHeader.vue";
import BadgeSuccess from "@/components/badge/BadgeSuccess.vue";
import BadgeWarning from "@/components/badge/BadgeWarning.vue";
import InputForm from "@/components/form/InputForm.vue";
import { formatDate } from "@/helpers/formating";
import { EyeIcon, TrashIcon, PencilIcon } from "@heroicons/vue/24/solid";
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    DinamicTable,
    TableRow,
    TableCell,
    Card,
    ButtonRouter,
    ButtonIcon,
    BadgeSuccess,
    BadgeWarning,
    EyeIcon,
    TrashIcon,
    PencilIcon,
    PageHeader,
    InputForm
  },
  data() {
    return {
      table_header_today_reminder: [
        'Title',
        'Customer',
        'Trx Date',
        'Product',
        'Status',
      ],
      table_header_birthday_reminder: [
        "Customer Name",
        "Birthdate",
        "Phone Number",
        "Last Transaction",
      ],

      customer_filter: {
        start_date: this.getDefaultStartDate(),
        end_date: this.getDefaultEndDate(),
      },

      products_count: 0,
      customers_count: 0,
    };
  },
  async created() {
    this.clearCustomers();
    this.clearReminders();

    this.fetchCustomers();
    this.fetchReminders();

    const params = {
      page: 1,
      limit: 1,
    };

    let products = await this.$store.dispatch('products/fetchProducts', params);
    this.products_count = products.pagination.totalItems;

    let customers = await this.$store.dispatch('customers/fetchCustomersCount', params);
    this.customers_count = customers.pagination.totalItems;
  },
  computed: {
    ...mapGetters('customers', ['allCustomers', 'allCustomersCount']),
    ...mapGetters('products', ['allProducts']),
    ...mapGetters('reminders', ['allReminders']),

    filteredBirthdayCustomers() {
      return this.allCustomers;
    },

    filteredReminders() {
      return this.allReminders;
    },

    page_title() {
      return this.$route.meta.page_title || "Untitled Page";
    },
    today() {
      return new Date().toISOString().split("T")[0];
    },
  },
  methods: {
    ...mapActions('reminders', ['clearReminders']),
    ...mapActions('customers', ['clearCustomers']),
    formatDate,

    async fetchCustomers() {
      const params = {
        start_date: this.customer_filter.start_date,
        end_date: this.customer_filter.end_date,
      };

      await this.$store.dispatch("customers/fetchCustomers", params);
    },

    async fetchReminders() {
      const params = {
        remind_date: new Date().toISOString().split('T')[0],
      };

      await this.$store.dispatch("reminders/fetchReminders", params);
    },
    getDefaultStartDate() {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
      return startDate.toISOString().split('T')[0];
    },

    getDefaultEndDate() {
      const endDate = new Date();
      endDate.setDate(endDate.getDate() + 15);
      return endDate.toISOString().split('T')[0];
    }
  },
};
</script>